export * as Api from './api';
export var TagName;
(function (TagName) {
    TagName["Direct"] = "Direct";
    TagName["VCT"] = "VCT";
    TagName["LP"] = "LP";
})(TagName || (TagName = {}));
export var TagTaxReliefType;
(function (TagTaxReliefType) {
    TagTaxReliefType["EIS"] = "EIS";
    TagTaxReliefType["SEIS"] = "SEIS";
    TagTaxReliefType["VCT"] = "VCT";
    TagTaxReliefType["KI"] = "EIS (KI)";
})(TagTaxReliefType || (TagTaxReliefType = {}));
//# sourceMappingURL=index.js.map